import createIcon from '../../createIcon';

/**
 * @component @name OilBarrel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTNDMjAuNTUgMTMgMjEgMTIuNTUgMjEgMTJDMjEgMTEuNDUgMjAuNTUgMTEgMjAgMTFIMTlWNUgyMEMyMC41NSA1IDIxIDQuNTUgMjEgNEMyMSAzLjQ1IDIwLjU1IDMgMjAgM0g0QzMuNDUgMyAzIDMuNDUgMyA0QzMgNC41NSAzLjQ1IDUgNCA1SDVWMTFINEMzLjQ1IDExIDMgMTEuNDUgMyAxMkMzIDEyLjU1IDMuNDUgMTMgNCAxM0g1VjE5SDRDMy40NSAxOSAzIDE5LjQ1IDMgMjBDMyAyMC41NSAzLjQ1IDIxIDQgMjFIMjBDMjAuNTUgMjEgMjEgMjAuNTUgMjEgMjBDMjEgMTkuNDUgMjAuNTUgMTkgMjAgMTlIMTlWMTNIMjBaTTEyIDE2QzEwLjM0IDE2IDkgMTQuNjggOSAxMy4wNUM5IDExLjc1IDkuNTIgMTEuMzggMTIgOC41QzE0LjQ3IDExLjM2IDE1IDExLjc0IDE1IDEzLjA1QzE1IDE0LjY4IDEzLjY2IDE2IDEyIDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OilBarrel = createIcon('OilBarrel', [
  [
    'path',
    {
      d: 'M20 13C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H19V5H20C20.55 5 21 4.55 21 4C21 3.45 20.55 3 20 3H4C3.45 3 3 3.45 3 4C3 4.55 3.45 5 4 5H5V11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H5V19H4C3.45 19 3 19.45 3 20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20C21 19.45 20.55 19 20 19H19V13H20ZM12 16C10.34 16 9 14.68 9 13.05C9 11.75 9.52 11.38 12 8.5C14.47 11.36 15 11.74 15 13.05C15 14.68 13.66 16 12 16Z',
      key: '7yoefe',
    },
  ],
]);

export default OilBarrel;
